<template>
<b-container
  class="bg-white py-5 d-flex section"
  fluid
  >
  <b-row class="justify-content-center align-self-center mx-auto">
    <b-col
      cols="12"
      lg="8"
      >
      <b-container class="text-center">
	<b-row>
	  <b-col
	    cols="12"
	    class="order-1"
	    >
	    <div class="d-flex pb-5">
	      <h1 class="m-auto m-sm-0">
		<slot name="header">Say hello to TrinPod<sup>&trade;</sup></slot>
	      </h1>
	    </div>
	  </b-col>
	  <b-col
	    cols="12"
	    sm="8"
	    class="order-3 order-sm-2"
	    >
	    <div class="mb-5">
	      <slot name="body">
		<p>TrinPod<sup>&trade;</sup> is an Industrial strength Solid Pod with conceptual computing through Trinity AI Capable of handling a massive amount of data</p>
	      </slot>
	    </div>
	  </b-col>
	  <b-col
	    cols="12"
	    sm="4"
	    class="pb-5 mb-sm-auto order-2 order-sm-3"
	    >
	    <slot name="icon">
	      <b-img
		:src="require('../assets/trinity_secure.png')"
		style="max-width: 200px; width: 100%; height: auto;"
		/>
	    </slot>
	  </b-col>
	</b-row>
      </b-container>
    </b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
    name: "TrinPodIntro"
}
</script>
